const fr = {
  //FiltersManager Component
  Search: "Buscar",
  "Add Filter": "Agregar Filtro",
  Name: "Name",
  Username: "Nom d'utilisateur",
  Password: "Contraseña",
  "Create account": "Crear cuenta",
  "Sign In Account": "Iniciar Sesión",
  "Sign Up Account": "Registro de Cuenta",
  "Reset password": "Resetear Contraseña",
  "Sign in to your account": "Connectez-vous à votre compte",
  "Sign In": "Se connecter",
  "Enter your username": "Ingrese su nombre de usuario",
  "Enter your password": "Ingrese su contraseña",
  "Forget your password? ": "Olvidó su contraseña? ",
  "No account? ": "No tiene una cuenta? ",
  "Username cannot be empty": "Su nombre de usuario no puede estar vacio",
  "User does not exist": "Usuario no existe",
  "Incorrect username or password": "Usuario o contraseña incorrecta",
  "Reset your password": "Resetear contraseña",
  "Back to Sign In": "Volver al inicio de sesión",
  "Send Code": "Enviar Código",
  "Create a new account": "Crear una nueva cuenta",
  "Create a username": "Crear un nombre de usuario",
  "Create a password": "Crear una contraseña",
  "Email Address": "Dirección de Email",
  "Phone Number": "Número de Teléfono",
  "Create Account": "Crear Cuenta",
  "Have an account? ": "Ya tiene una cuenta? ",
  "Sign in": "Iniciar sesión",
  "Password cannot be empty": "La Contraseña no puede estar en vacía",
  "Invalid password format": "Formato de contraseña no es válido",
  "Attribute value for phone_number must not be null":
    "El valor del atributo para número de teléfono no puede ser nulo",
  "Invalid email address format.": "Formato de correo electrónico inválido",
  "Confirm Sign Up": "Confirmar Registro",
  "Confirmation Code": "Confirmar Código",
  "Enter your code": "Ingrese su código",
  "Lost your code? ": "Perdió su código? ",
  "Resend Code": "Reenviar Código",
  Confirm: "Confirmar",
  "Invalid verification code provided, please try again.":
    "Se ha proporcionado un código de verificación no válido, inténtalo de nuevo.",
  "Sign In with Facebook": "Iniciar sesión usando Facebook",
  "Family name": "Apellido",
  "Given name": "Nombre",
  or: "o",
  "User account has expired, it must be reset by an administrator.":
    "La cuenta de usuario ha caducado, debe ser restablecida por un administrador.",
  //ForgotPassword Component
  "Code has been sent": "Su código ha sido enviado",
  "New Password": "Nueva Contraseña",
  Code: "Código",
  Continue: "Siguiente",
  Cancel: "Cancelar",
  "User already exists": "El usuario ya existe",
  "Your password has been updated": "Su contraseña ha sido actualizada",

  //AWS Cognito API errors messages
  "User does not exist.": "Usuario no existe",
  "Incorrect username or password.": "Usuario o contraseña incorrecta",
  "Attempt limit exceeded, please try after some time.":
    "Se ha superado el límite de intentos, por favor intente de nuevo más tarde.",
  "Username/client id combination not found.":
    "Combinación de nombre de usuario / identificación de cliente no encontrada.",
  "User cannot be confirm. Current status is CONFIRMED":
    "El usuario ya ha sido confirmado",

  //Filter Component
  "New Filter": "Nuevo Filtro"
};

export default fr;
